'use client'

import { Transition } from '@headlessui/react'

import { type CustomerReviewItem } from '@src/components/CustomerReviews/CustomerReviews.props'
import { StarRating } from '@src/components/CustomerReviews/StarRating'

export const CustomerReviewCard = (
  props: CustomerReviewItem & { shouldAnimate?: boolean; color?: string }
) => {
  const { content, name, product, ratingOutOfFive, shouldAnimate, color } = props

  return (
    <Transition show appear={shouldAnimate}>
      <div
        style={{ boxShadow: '0px 8px 16px 0px #1618190D' }}
        className="
          relative rounded-3xl bg-bodi-white p-8 text-bodi-black-text
          transition duration-300 ease-in data-closed:opacity-0"
      >
        <div className="font-medium">{name}</div>
        <div
          className="text-body-xs text-bodi-gray-medium"
          dangerouslySetInnerHTML={{ __html: product ?? '' }}
        ></div>
        <div className="my-4 h-px bg-bodi-gray-light"></div>
        <div className="mb-2">
          <StarRating color={color} ratingOutOfFive={ratingOutOfFive ?? 0} />
        </div>
        <div className="prose" dangerouslySetInnerHTML={{ __html: content ?? '' }}></div>
      </div>
    </Transition>
  )
}
